export const REQUEST_STATUSES = `
  query requestStatuses(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: RequestStatusOrderInput
    $filter: RequestStatusFilterInput
    $searchText: String
  ) {
    requestStatuses(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on RequestStatus {
        id
        name
        translation_key
        hex_color
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
